import { useEffect, useRef } from "react";
import { CustomersFilter } from "./useCustomersFilter";

export const defaultPageSettings = {
  page: 1,
  pageSize: 100,
};

interface UseClearDropdownEffectProps {
  customerFilter?: CustomersFilter;
  searchValueRef: React.MutableRefObject<string>;
  pageSettingsRef: React.MutableRefObject<{ page: number; pageSize: number }>;
  fetchOrganizations: () => Promise<void>;
  openPopup: boolean;
}

export const useClearDropdownEffect = ({
  customerFilter,
  searchValueRef,
  pageSettingsRef,
  fetchOrganizations,
  openPopup,
}: UseClearDropdownEffectProps) => {
  const prevCustomerFilterRef = useRef<string | undefined>(
    customerFilter?.customers
  );

  useEffect(() => {
    const wasCleared =
      prevCustomerFilterRef.current && !customerFilter?.customers;
    const hadSearchValue = searchValueRef.current !== "";

    if (wasCleared && hadSearchValue && !openPopup) {
      searchValueRef.current = "";
      pageSettingsRef.current = { ...defaultPageSettings };
      fetchOrganizations();
    }

    prevCustomerFilterRef.current = customerFilter?.customers;
  }, [
    customerFilter?.customers,
    openPopup,
    searchValueRef,
    pageSettingsRef,
    fetchOrganizations,
  ]);
};
